import { getRequest, postRequest, putRequest, deleteRequest } from './api';

const objetivosApi = {
  // Obtener todos los objetivos de una marca
  async getObjetivos(brandId = null) {
    const params = brandId ? { brand_id: brandId } : {};
    const response = await getRequest('/api/objetivos', {}, params);
    return response;
  },

  /** Recalcula valor_actual de todos los objetivos de la marca. */
  async refreshMetrics(brandId = null) {
    const body = brandId ? { brand_id: brandId } : {};
    const response = await postRequest('/api/objetivos/refresh-metrics', body);
    return response;
  },

  // Obtener un objetivo específico por ID
  async getObjetivo(objetivoId) {
    // Validar que objetivoId sea válido
    if (!objetivoId) {
      throw new Error('Error: El objetivoId es requerido.');
    }
    
    const response = await getRequest(`/api/objetivos/${objetivoId}`);
    return response;
  },

  // Crear un nuevo objetivo
  async createObjetivo(objetivoData) {
    // Validar que objetivoData tenga un brand_id válido
    if (!objetivoData || !objetivoData.brand_id) {
      throw new Error('Error: El objetivo debe tener un brand_id válido.');
    }
    
    const response = await postRequest('/api/objetivos', objetivoData);
    return response;
  },

  // Actualizar un objetivo existente
  async updateObjetivo(objetivoId, objetivoData) {
    // Validar que si objetivoData incluye brand_id, sea válido
    if (objetivoData && objetivoData.brand_id !== undefined && !objetivoData.brand_id) {
      throw new Error('Error: El brand_id proporcionado no es válido.');
    }
    
    const response = await putRequest(`/api/objetivos/${objetivoId}`, objetivoData);
    return response;
  },

  // Eliminar un objetivo
  async deleteObjetivo(objetivoId) {
    // Validar que objetivoId sea válido
    if (!objetivoId) {
      throw new Error('Error: El objetivoId es requerido.');
    }
    
    const response = await deleteRequest(`/api/objetivos/${objetivoId}`);
    return response;
  },

  // Agregar una campaña a un objetivo
  async addCampanaToObjetivo(objetivoId, campanaId) {
    // Validar que objetivoId y campanaId sean válidos
    if (!objetivoId) {
      throw new Error('Error: El objetivoId es requerido.');
    }
    if (!campanaId) {
      throw new Error('Error: El campanaId es requerido.');
    }
    
    const response = await postRequest(`/api/objetivos/${objetivoId}/campanas`, { campana_id: campanaId });
    return response;
  },

  // Remover una campaña de un objetivo
  async removeCampanaFromObjetivo(objetivoId, campanaId) {
    // Validar que objetivoId y campanaId sean válidos
    if (!objetivoId) {
      throw new Error('Error: El objetivoId es requerido.');
    }
    if (!campanaId) {
      throw new Error('Error: El campanaId es requerido.');
    }
    
    const response = await deleteRequest(`/api/objetivos/${objetivoId}/campanas/${campanaId}`);
    return response;
  },

  // Actualizar conversiones relacionadas de un objetivo
  async updateObjetivoConversiones(objetivoId, conversionesData) {
    // Validar que objetivoId sea válido
    if (!objetivoId) {
      throw new Error('Error: El objetivoId es requerido.');
    }
    // Validar que si conversionesData incluye brand_id, sea válido
    if (conversionesData && conversionesData.brand_id !== undefined && !conversionesData.brand_id) {
      throw new Error('Error: El brand_id proporcionado no es válido.');
    }
    
    const response = await postRequest(`/api/objetivos/${objetivoId}/metricas`, conversionesData);
    return response;
  },

  // Actualizar métricas de un objetivo (valor actual y proyectado)
  async actualizarMetricasObjetivo(objetivoId) {
    // Validar que objetivoId sea válido
    if (!objetivoId) {
      throw new Error('Error: El objetivoId es requerido.');
    }
    
    const response = await postRequest(`/api/objetivos/${objetivoId}/actualizar-metricas`, {});
    return response;
  },

  // Generar objetivos automáticos para Google
  // selectedConversionIds: array opcional de IDs de conversiones a usar
  async autoGenerateGoogle(selectedConversionIds = [], selectedObjectiveMetrics = []) {
    const params = {};
    if (Array.isArray(selectedConversionIds) && selectedConversionIds.length > 0) {
      params.conversiones_ids = selectedConversionIds.join(',');
    }
    if (Array.isArray(selectedObjectiveMetrics) && selectedObjectiveMetrics.length > 0) {
      params.objetivo_metricas = selectedObjectiveMetrics.join(',');
    }
    const response = await getRequest('/api/objetivos/auto-generate/google', {}, params);
    return response;
  },

  // Generar objetivos automáticos para Meta
  // selectedConversionIds: array opcional de IDs de conversiones a usar
  async autoGenerateMeta(selectedConversionIds = [], selectedObjectiveMetrics = []) {
    const params = {};
    if (Array.isArray(selectedConversionIds) && selectedConversionIds.length > 0) {
      params.conversiones_ids = selectedConversionIds.join(',');
    }
    if (Array.isArray(selectedObjectiveMetrics) && selectedObjectiveMetrics.length > 0) {
      params.objetivo_metricas = selectedObjectiveMetrics.join(',');
    }
    const response = await getRequest('/api/objetivos/auto-generate/meta', {}, params);
    return response;
  }
};

export default objetivosApi;
